import { Link } from "react-router";

export function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white/40 px-4 py-6 sm:px-6">
      <div className="mx-auto max-w-6xl flex flex-col items-center gap-3 text-xs text-slate-500 sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} Carmen — Alle rechten voorbehouden.</p>
        <nav className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/about" className="hover:text-slate-700">Over Carmen</Link>
          <Link to="/contact" className="hover:text-slate-700">Contact</Link>
          <Link to="/#pricing" className="hover:text-slate-700">Prijzen</Link>
          <Link to="/privacy" className="hover:text-slate-700">Privacy</Link>
          <Link to="/terms" className="hover:text-slate-700">Gebruiksvoorwaarden</Link>
          <Link to="/trust" className="hover:text-slate-700">Trust Center</Link>
        </nav>
      </div>
    </footer>
  );
}
